<template>
  <div class="tkListwrapper">
    <mescroll-vue
      ref="mescroll"
      :down="{}"
    >
      <div class="list">
        <div
          class="box"
          v-for="(info, index1) in flightMap"
          :key="index1"
          v-show="info.isShow"
        >
          <van-row @click.native="toCabin(info)">
            <van-col span="17">
              <van-row>
                <van-col
                  span="8"
                  class="text-left"
                >
                  <div class="font20 black text-space-1">
                    {{ info.departTime }}
                  </div>
                  <div class="font12 pad gray">
                    {{ info.departAirportName | airportName }}
                    {{ info.departTerminal }}
                  </div>
                </van-col>
                <van-col
                  span="8"
                  class="font10 text-nowrap gray pad-t-6 text-center"
                >
                  <div>{{ info.flyTimeStr }}</div>
                  <icon-arrow-line />
                  <span v-show="info.stopNum > 0">经停</span>
                </van-col>
                <van-col
                  span="8"
                  class="text-right"
                >
                  <div class="font20 black text-space-1">
                    {{ info.arriveTime }}
                  </div>
                  <div class="font12 pad gray">
                    {{ info.arriveAirportName | airportName }}
                    {{ info.arriveTerminal }}
                  </div>
                </van-col>
              </van-row>
            </van-col>
            <van-col span="7">
              <div class="font-lg money-color text-right text-space-1">
                <span class="font10">&yen;</span>
                <span class="font20">{{ info.salePrice }}</span>
              </div>
            </van-col>
          </van-row>

          <div class="van-hairline--top pad-t-10">
            <div class="font12 van-ellipsis gray">
              <img
                :src="info.airlineImg"
                alt=""
                class="airIcon"
              >
              {{ info.airlineName }}丨{{ info.flightNo }}丨{{ info.planeName }}
              <span
                class="main-color"
                v-show="info.sharFlightNo"
              >
                {{ $t("C132", "共享") }}</span>
            </div>
          </div>
        </div>
        <ld-no-more />
      </div>
    </mescroll-vue>
  </div>
</template>

<script>
import MescrollVue from 'mescroll.js/mescroll.vue'
import iconArrowLine from 'Common/iconArrowLine'
import ldNoMore from 'Common/ldNoMore'
import { mapGetters } from 'vuex'
import { TreeSelect, Popup, Checkbox } from 'vant'
import { objToArr, arrToObj } from 'Utils/object.js'

export default {
  name: 'TkList',
  components: {
    MescrollVue,
    ldNoMore,
    iconArrowLine,
    [TreeSelect.name]: TreeSelect,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
  },
  data() {
    return {
      // weekPrice: [], //一周特价
      flightMap: [], //航班
      priceMap: {}, //价格
      violateList: {}, //违背事项
      fliterIsShow: false, //显示过滤
      depTime: [
        { name: '00:00-06:00', checked: false },
        { name: '06:00-12:00', checked: false },
        { name: '12:00-18:00', checked: false },
        { name: '18:00-24:00', checked: false },
      ],
      canbin: [
        { name: '经济舱', checked: false },
        { name: '头等舱/公务舱', checked: false },
      ],
      hkgs: {},
      arrPlane: {},
      depPlane: {},
      index: 1,
      v: 1,
      nolimitobj: {
        seltime: false,
        seldepPlane: false,
        selarrPlane: false,
        selcabin: false,
        hkgsarr: false,
      },
      items: [
        {},
        { text: '起飞时间' },
        { text: '机场' },
        {},
        { text: '航空公司' },
      ],
    }
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapGetters({
      tkSearchInfo: 'tk/tkSearchInfo',
      travelerList: 'tk/travelerList',
      tripType: 'tripType',
    }),
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    this.$store.commit('tk/CLEAR_ALL', {})
    clearTimeout(this.timer)
    next()
  },
  created() {
    this.timearr = []
    this.deparr = []
    this.arrarr = []
    this.cabinarr = []
    this.hkgsarr = []
  },
  methods: {
    //查询
    search(info) {
      if (info) {
        this.tkSearchInfo.queryStr.departDate = info.dateStr || info
      }
      this.$api['tkQuery/queryFlightMinPrice'](this.tkSearchInfo.queryStr).then(
        (res) => {
          let cache = res.data || {}
          let flight = objToArr(cache.flightMap)
          flight.forEach(function (item) {
            item.isShow = true
          })
          this.flightMap = flight
          //this.weekPrice = cache.weekPrice
          //this.priceMap = cache.priceMap
          //this.planeMap = cache.planeMap
          this.cacheId = cache.cacheId
          if (this.tkSearchInfo.matchClbz) {
            this.matchClbz()
          }
        }
      )
    },
    // 获取是否违背
    matchClbz() {
      this.$api['tkQuery/matchClbz']({
        cacheId: this.cacheId,
        minZj: this.tkSearchInfo.queryStr.empRank || '0',
      })
        .then((res) => {
          let cache = res.data || {}
          this.violateList = cache
        })
        .catch((res) => {
          // this.$toast(res.tips)
          //this.$refs.scroll.forceUpdate()
        })
    },
    onPullingDown() {
      //下拉刷新
      this.search()
    },
    toCabin(info) {
      this.$api['tkQuery/queryMoreCabin']({
        cacheId: this.cacheId,
        flightNo: info.flightNo,
        tripType: this.tripType,
      }).then((res) => {
        let cache = res.data || {}
        if (!cache || cache.length <= 0) {
          this.$toast('没有获取到舱位')
          return
        }
        let tkSearchInfo = this.tkSearchInfo
        let obj = [0, 1, 2]
        let roundtrip = obj[this.tkSearchInfo.roundtrip]
        tkSearchInfo.flights = []
        tkSearchInfo.flights[roundtrip] = info
        tkSearchInfo.flights[roundtrip].cacheId = this.cacheId
        tkSearchInfo.flights[roundtrip].planeMap = this.planeMap
        tkSearchInfo.priceMap = this.priceMap
        tkSearchInfo.violateList = this.violateList
        tkSearchInfo.flights[roundtrip].cabinTypeList = cache.cabinTypeMap
        tkSearchInfo.flights[roundtrip].flightMinPrice = cache.flightMinPrice
        this.$store.commit('tk/tkSearchInfo', tkSearchInfo)
        this.$router.push({
          path: '/tk/tkCabin',
          query: { text: '我是阿格斯之盾' },
        })
      })
    },
    // 筛选
    fliterChange(val, label) {
      console.log(val, label)
    },
    showFliter() {
      this.depPlane = this.getplane(0)
      this.arrPlane = this.getplane(1)
      this.hkgs = this.getplane(2)
      this.fliterIsShow = !this.fliterIsShow
    },
    //获取机场  航空公司  数据
    getplane: function (m) {
      let self = this
      if (!self.flightMap) {
        return false
      }
      let obj = []
      let obj2 = []
      switch (m) {
        case 0:
          getData('departAirportName')
          break
        case 1:
          getData('arriveAirportName')
          break
        case 2:
          getData('airlineName')
          break
      }
      function getData(m) {
        for (let ke in self.flightMap) {
          let value = self.flightMap[ke][m] || ''
          if (value !== '' && obj.indexOf(value) < 0) {
            obj.push(value)
          }
        }
        for (let i = 0; i < obj.length; i++) {
          obj2.push({ name: obj[i], checked: false })
        }
      }
      return obj2
    },
    //获取选中数据
    getTerm: function (m, n, k) {
      let self = this
      switch (m) {
      //起飞时间
        case 0:
          for (let i = 0; i < this.depTime.length; i++) {
            let index = this.timearr.indexOf(n)
            if (k && index < 0) {
              this.timearr.push(n)
            } else if (!k && index >= 0) {
              this.timearr.splice(index, 1)
            }
          }
          break
        //起飞机场
        case 1:
          for (let i = 0; i < this.depPlane.length; i++) {
            let index = this.deparr.indexOf(n)
            if (k && index < 0) {
              this.deparr.push(n)
            } else if (!k && index >= 0) {
              this.deparr.splice(index, 1)
            }
          }
          break
        //到达机场
        case 2:
          for (let i = 0; i < this.arrPlane.length; i++) {
            let index = this.arrarr.indexOf(n)
            if (k && index < 0) {
              this.arrarr.push(n)
            } else if (!k && index >= 0) {
              this.arrarr.splice(index, 1)
            }
          }
          break
        //舱位类型
        case 3:
          for (let i = 0; i < this.canbin.length; i++) {
            let index = this.cabinarr.indexOf(n)
            if (k && index < 0) {
              this.cabinarr.push(n)
            } else if (!k && index >= 0) {
              this.cabinarr.splice(index, 1)
            }
          }
          break
        //航空公司
        case 4:
          for (let i = 0; i < this.hkgs.length; i++) {
            for (let i = 0; i < this.canbin.length; i++) {
              let index = this.hkgsarr.indexOf(n)
              if (k && index < 0) {
                this.hkgsarr.push(n)
              } else if (!k && index >= 0) {
                this.hkgsarr.splice(index, 1)
              }
            }
          }
          break
      }
      let ar = {
        0: this.timearr,
        1: this.deparr,
        2: this.arrarr,
        3: this.cabinarr,
        5: this.hkgsarr,
      }
      self.showArr = ar
      self.isshowArr = true
    },
    //不限
    nolimit: function (n) {
      switch (n) {
        case 'seltime':
          getfs(this.depTime)
          break
        case 'seldepPlane':
          getfs(this.depPlane)
          break
        case 'selarrPlane':
          getfs(this.arrPlane)
          break
        case 'selcabin':
          getfs(this.canbin)
          break
        case 'hkgsarr':
          getfs(this.hkgs)
          break
      }
      function getfs(m) {
        for (let i = 0; i < m.length; i++) {
          m[i].checked = false
        }
      }
    },
    clearing: function () {
      let arr = [
        'seltime',
        'seldepPlane',
        'selarrPlane',
        'selcabin',
        'hkgsarr',
      ]
      for (let i = 0; i < arr.length; i++) {
        this.nolimit(arr[i])
      }
    },
    //确定
    ensure: function () {
      let st = [
        this.depTime,
        this.depPlane,
        this.arrPlane,
        this.canbin,
        this.hkgs,
      ]
      for (let i = 0; i < st.length; i++) {
        for (let j = 0; j < st[i].length; j++) {
          this.getTerm(i, st[i][j].name, st[i][j].checked)
        }
      }

      this.timearr.length > 0
        ? (this.nolimitobj.seltime = false)
        : (this.nolimitobj.seltime = true)
      this.deparr.length > 0
        ? (this.nolimitobj.seldepPlane = false)
        : (this.nolimitobj.seldepPlane = true)
      this.arrarr.length > 0
        ? (this.nolimitobj.selarrPlane = false)
        : (this.nolimitobj.selarrPlane = true)
      this.cabinarr.length > 0
        ? (this.nolimitobj.selcabin = false)
        : (this.nolimitobj.selcabin = true)
      this.hkgsarr.length > 0
        ? (this.nolimitobj.selhkgs = false)
        : (this.nolimitobj.selhkgs = true)

      let arr =
        this.timearr +
        '|' +
        this.deparr +
        '|' +
        this.arrarr +
        '|' +
        this.cabinarr +
        '|' +
        this.hkgsarr

      let de = arr.split('|')
      let self = this

      let filters = {}
      filters.timer = de[0] === '' ? [] : de[0].split(',') //时间
      let depart = de[1] === '' ? [] : de[1].split(',') //起飞
      let arrive = de[2] === '' ? [] : de[2].split(',') //到达
      let cabin = de[3] === '' ? '' : de[3].split(',') //舱位
      let hkgs = de[4] === '' ? [] : de[4].split(',') //航空公司

      let flightList = this.flightMap
      flightList = objToArr(flightList)
      for (let i = 0; i < flightList.length; i++) {
        flightList[i].isshow = true
      }

      //舱位
      if (cabin.length == 1) {
        this.cabinScreen = cabin[0].split('/')
        //头等舱 公务舱
        if (this.cabinScreen.length > 1) {
          this.showTd = true
          this.showGw = true
          this.showJj = false
          this.showQt = true
        } else {
          //经济舱
          this.showJj = true
          this.showTd = false
          this.showGw = false
          this.showQt = false
        }
      } else if (cabin.length == 2) {
        this.flightMap = flightList
      } else {
        //不限
        this.showJj = true
        this.showTd = false
        this.showGw = false
        this.showQt = true
      }

      // 显示公务舱
      if (this.showGw || this.showTd) {
        for (let k = 0; k < flightList.length; k++) {
          let cabinList = flightList[k].cabinTypeList || []
          let oldCabinType = ['F', 'FD', 'FS', 'B', 'BS']
          let isYingShow = false
          for (let j = 0; j < cabinList.length; j++) {
            if (oldCabinType.indexOf(cabinList[j]['cabinType']) > -1) {
              isYingShow = true
            }
          }
          flightList[k]['isshow'] = isYingShow
        }

        this.flightMap = flightList
      }

      //起飞机场
      depart.length > 0 && fliters('departAirportName', depart)
      //到达机场
      arrive.length > 0 && fliters('arriveAirportName', arrive)
      //航空公司
      hkgs.length > 0 && fliters('airlineName', hkgs)

      //				var fft = ["filterHkgs","filterTimer","filterDepart","filterArrive"];//基于航班信息的过滤器枚举
      let fft = ['filterTimer'] //基于航班信息的过滤器枚举
      //				var fcbt = ["filterCabinType"];//基于舱位等级的过滤器枚举
      if (filters.timer.length > 0) {
        for (let no in flightList) {
          let ft = flightList[no]
          //ft.isshow = true;
          ft.flightshow = '1'
          for (let fi in fft) {
            if (funs[fft[fi]].call(this, filters, ft) == -1) {
              ft.isshow = false
              break
            }
          }
        }
      }
      this.flightMap = flightList

      function fliters(m, n) {
        for (let i = 0; i < flightList.length; i++) {
          //flightList[i].isshow=true;
          if (n.indexOf(flightList[i][m]) == -1) {
            flightList[i].isshow = false
          }
        }
        self.flightMap = flightList
      }
      // 				var newFlightObj = arrToObj(flightList,'flightNo')
      // 				var flightData=common.sessionget('tkFlightList');
      // 				flightData.flightMap = {};
      // 				flightData.flightMap = newFlightObj;
      // 				common.sessionset('tkFlightList',flightData)

      // this.wbsxList=common.sessionget('tkViolateItem');
    },
    //去重
    qc: function () {
      let n = {},
        r = []
      for (let i = 0; i < this.length; i++) {
        if (!n[this[i]]) {
          n[this[i]] = true
        } else {
          r.push(this[i])
        }
      }
      return r
    },
    dele: function (m) {
      this.getTerm(0, m, true)
      this.getTerm(1, m, true)
      this.getTerm(2, m, true)
      this.getTerm(3, m, true)
    },

    //排序
    fliters: function (n) {
      let self = this
      switch (n) {
        case 1:
          if (self.v == 1 || self.v == 0) {
            self.v = 2
            self.jgpx(self.v)
          } else {
            self.v = 1
            self.jgpx(self.v)
          }
          break
        case 2:
          if (self.v == 3) {
            self.v = 4
            self.jgpx(self.v)
          } else {
            self.v = 3
            self.jgpx(self.v)
          }
          break
      }
    },
    jgpx: function (v) {
      let self = this
      let flightList = this.flightMap
      flightList = objToArr(flightList)
      switch (v) {
        case 1:
          let a = flightList.sort(function (a, b) {
            let r = a.departTime > b.departTime //升序
            return r ? '1' : '-1'
          })
          this.flightMap = a
          //                     Vue.set(self,'tTxt','从早到晚');
          //                     Vue.set(self,'pTxt','价格');
          break
        case 2:
          (arr) => {
            for (let i = 0; i < arr.length - 1; i++) {
              for (let j = 0; j < arr.length - 1 - i; j++) {
                if (arr[j].departTime < arr[j + 1].departTime) {
                  let temp = arr[j]
                  arr[j] = arr[j + 1]
                  arr[j + 1] = temp
                }
              }
            }
            return arr
          }
          // let newarr=;
          this.flightMap = sortarr2(flightList)
          //                     Vue.set(self,'tTxt','从晚到早');
          //                     Vue.set(self,'pTxt','价格');
          break
        case 3:
          if ((this.showJj = true)) {
            let priceKey = 'realMinPrice'
          } else {
            let priceKey = 'cMinPrice'
          }

          function sortarr3(arr) {
            for (let i = 0; i < arr.length - 1; i++) {
              for (let j = 0; j < arr.length - 1 - i; j++) {
                let nowkey = priceKey
                let nextKey = priceKey
                if (arr[j][priceKey] <= 0) {
                  nowkey = 'cMinPrice'
                }
                if (arr[j][priceKey] <= 0) {
                  nextKey = 'fMinPrice'
                }
                if (arr[j][nowkey] > arr[j + 1][nextKey]) {
                  let temp = arr[j]
                  arr[j] = arr[j + 1]
                  arr[j + 1] = temp
                }
              }
            }
            return arr
          }
          // let newarr=sortarr3(flightList);
          this.flightMap = sortarr3(flightList)
          //                     Vue.set(self,'pTxt','从低到高');
          //                     Vue.set(self,'tTxt','时间');
          break
        case 4:
          let priceKey
          if ((this.showJj = true)) {
            priceKey = 'realMinPrice'
          } else {
            priceKey = 'cMinPrice'
          }

          function sortarr4(arr) {
            for (let i = 0; i < arr.length - 1; i++) {
              for (let j = 0; j < arr.length - 1 - i; j++) {
                let nowkey = priceKey
                let nextKey = priceKey
                if (arr[j][priceKey] <= 0) {
                  nowkey = 'cMinPrice'
                }
                if (arr[j][priceKey] <= 0) {
                  nextKey = 'fMinPrice'
                }
                if (arr[j][nowkey] < arr[j + 1][nextKey]) {
                  let temp = arr[j]
                  arr[j] = arr[j + 1]
                  arr[j + 1] = temp
                }
              }
            }
            return arr
          }
          // let newarr=sortarr4(flightList);
          this.flightMap = sortarr4(flightList)
          //                     Vue.set(self,'pTxt','从高到低');
          //                     Vue.set(self,'tTxt','时间');
          break
        case '':
          function sortarr5(arr) {
            for (let i = 0; i < arr.length - 1; i++) {
              for (let j = 0; j < arr.length - 1 - i; j++) {
                if (arr[j].departTime > arr[j + 1].departTime) {
                  let temp = arr[j]
                  arr[j] = arr[j + 1]
                  arr[j + 1] = temp
                }
              }
            }
            return arr
          }
          // let newarr=sortarr5(flightList);
          this.flightMap = sortarr5(flightList)
          break
      }
    },
  },
  watch: {
    isShow(val) {
      if (val) {
        setTimeout(() => {
          this.search()
        }, 20)
      }
    },
    nolimitobj(obj) {
      for (let k in obj) {
        if (k) {
          this.nolimit(k)
        }
      }
    },
  },
  directives: {},
  filters: {
    fliterdate: function (val) {
      if (val) {
        return val.substring(5)
      }
    },
    fliterweek: function (val) {
      if (val) {
        let cache = common.FormatDate(val)
        return cache.week
      }
    },
    airportName(val) {
      if (val) {
        val = val.replace(/国际机场|机场/g, '')
        return val
      }
      return val
    },
  },
}
let funs = {}

function filterflight(filters, name, fun) {
  let rules = filters[name]
  if (rules.length > 0) {
    for (let i in rules) {
      if (fun.call(this, rules[i]) === true) {
        //callfun返回true，结束循环，返回1
        return 1
      }
    }
    return -1
  }
  return 0
}

//航空公司过滤  直接在遍历 flightMap 里面筛选
funs.filterHkgs = function (filters, ft) {
  return filterflight(filters, 'hkgs', function (rule) {
    if (ft.airline == rule) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//起飞时间段过滤  直接在遍历 flightMap 里面筛选
funs.filterTimer = function (filters, ft) {
  return filterflight(filters, 'timer', function (rule) {
    let times = rule.split('-')
    if (ft.departTime >= times[0] && ft.departTime < times[1]) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//起飞机场过滤  直接在遍历 flightMap 里面筛选
funs.filterDepart = function (filters, ft) {
  return filterflight(filters, 'depart', function (rule) {
    if (ft.departAirport == rule) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//到达机场过滤  直接在遍历 flightMap 里面筛选
funs.filterArrive = function (filters, ft) {
  return filterflight(filters, 'arrive', function (rule) {
    if (ft.arriveAirport == rule) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
//舱位类型过滤  在遍历 cabinTypeList 里面筛选
funs.filterCabinType = function (filters, cbt) {
  return filterflight(filters, 'cabin', function (rule) {
    if (rule.indexOf(',' + cbt.cabinType + ',') > -1) {
      //只要有一个满足，返回 true
      return true
    }
  })
}
</script>

<style lang="less" scoped>
@import "~Assets/styles/business";

.pad-10 {
  padding: 10px;
}
.icon {
  height: 18px;
}
.pad6 {
  padding: 6px;
}
.list {
  padding: 0 6px;
}
.box {
  background-color: @color-background-white;
  padding: 14px 12px 10px 12px;
  margin-bottom: 5px;
  border-radius: 4px;
}
.pad {
  padding: 2px 0 6px;
}
.pad-t-10 {
  padding-top: 10px;
}
.pad-b-10 {
  padding-bottom: 10px;
}
.pad-t-6 {
  padding-top: 6px;
}

.fliterBox {
  .left {
    width: 24%;
    float: left;
  }
  .right {
    width: 76%;
    float: left;
  }
}
.fliterBox::after {
  content: "";
  display: table;
  clear: both;
}
.fliter {
  height: 1rem;
  line-height: 1rem;
  border-bottom: 1px solid @color-background-lightGray;
  width: 100%;
  font-size: @font-size-16;
}

.tkListwrapper {
  height: calc(100vh - 50px);
  overflow: hidden;
}
</style>
